import { render, staticRenderFns } from "./GpathSkillRecoEdit.vue?vue&type=template&id=33de84d2&scoped=true"
import script from "./GpathSkillRecoEdit.vue?vue&type=script&lang=js"
export * from "./GpathSkillRecoEdit.vue?vue&type=script&lang=js"
import style0 from "./GpathSkillRecoEdit.vue?vue&type=style&index=0&id=33de84d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de84d2",
  null
  
)

export default component.exports